import { observer } from 'mobx-react-lite'
import { type BookkeepingSelectCycleDialogViewModel } from './BookkeepingSelectCycleDialogViewModel'
import {
  formatCycleCompletedItems,
  formatCycleCompletionDate,
} from '@/features/jobs/bookkeeping/bookkeeping-cycle-formatters'
import {
  BookkeepingSelectCycleDialog,
  BookkeepingSelectCycleListItem,
} from '@/features/jobs/details/components/BookkeepingSelectCycleDialog'

export interface BookkeepingSelectCycleDialogContainerProps {
  vm: BookkeepingSelectCycleDialogViewModel
}

export const BookkeepingSelectCycleDialogContainer = observer(
  function BookkeepingSelectCycleDialogContainer({
    vm,
  }: BookkeepingSelectCycleDialogContainerProps) {
    return (
      <BookkeepingSelectCycleDialog
        showing={vm.modal.showing}
        onClose={vm.modal.close}
      >
        {vm.completedCycles?.map((cc) => (
          <BookkeepingSelectCycleListItem
            key={cc.id}
            number={cc.number}
            completionDate={formatCycleCompletionDate(cc)}
            completedItems={formatCycleCompletedItems(cc)}
            onSelect={() => vm.selectCycle(cc)}
          />
        ))}
      </BookkeepingSelectCycleDialog>
    )
  },
)
